import React from "react";
import './App.css';
import Navbar from "./Navbar";
import {
    BrowserRouter as Router,
    Switch,
    Route,
    Link
  } from "react-router-dom";
function Home(){
    return(
        <>
        <section id='banner'>
            <div className="banner-cnt">
                <Navbar />
            <div className="container">
                    <div className="row banner-row">
                        <div className="col-md-2 col-sm-12 col-12 col-lg-2">

                        </div>
                        <div className="col-md-8 col-sm-12 col-12 col-lg-8" style={{textAlign:"center"}} data-aos="zoom-in">
                            <h1 className="banner-h1">
                                FORGOTTEN
                            </h1>
                            <h1 className="banner-h1 second-h1">
                                ETHEREAL
                            </h1>
                            <h1 className="banner-h1 third-h1">
                                WORLDS
                            </h1>

                            <Link to="/rift" className="enter-link">
                                Enter the RIFT
                            </Link>
                        </div>
                        <div className="col-md-2 col-sm-12 col-12 col-lg-2">
                            
                        </div>
                    </div>
                </div>
            </div>
      </section>
        </>
    );
}

export default Home;